function showDesignInfoSummary() {
  const design = activeProject.design;

  let str = String.raw`
    <div class="card-header">
      <h4>
        <span class="float-start">Design Info</span>
        <span class="float-end">${activeProject.designTypeStr}</span>
      </h4>
    </div>`


  str += "<table class='table'>";
  str += makeSummaryRow('Shape Type', activeProject.shapeName)

  if (activeProject.isEngineeredLumber) {
    str += makeSummaryRow('Number of Plys', activeProject.numberOfPlys)
  }

  if (activeProject.shape.flitch) {
    const thickness = activeProject.shape.flitch.plateThickness
    const height = activeProject.shape.flitch.plateHeight
    const nPlates = activeProject.shape.flitch.numberOfPlates
    str += makeSummaryRow('Flitch Steel', `${nPlates} (${thickness} &times; ${height})`)
  }

  str += makeSummaryRow(`Weight ${activeProject.shape.flitch ? "(includes flitch steel)" : ""}`, activeProject.shapeWeightString)

  str += makeSummaryRow('Self Weight', design.includeSelfWeight ? "Included" : "Not Included")

  str += makeSummaryRow(`Ix ${activeProject.shape.flitch ? "(includes flitch steel)" : ""}`, activeProject.shapeIxString)

  if (!activeProject.isEngineeredLumber && !activeProject.isCustom && !activeProject.isFormTechShape && activeProject.beam.crossSectionRotation > 0) {
    str += makeSummaryRow('Iy', activeProject.shapeIyString)
    str += makeSummaryRow('Cross Section Rotation', `${activeProject.beam.crossSectionRotation}&deg;`)
  }

  //continuous, equal, custom, unbraced
  if (activeProject.isEngineeredLumber) {
    str += makeSummaryRow('Bracing', 'Continuous Assumed')
  } else if (design.bracingType === 'continuous') {
    str += makeSummaryRow('Bracing', 'Continuous')
  } else if (design.bracingType === "equal") {
    str += makeSummaryRow('Bracing', `Braced @ ${showSmallLengthWithUnits(activeProject.design.getBraceSpacing())}`)
  } else if (design.bracingType === "unbraced") {
    str += makeSummaryRow('Bracing', 'None')
  } else {
    str += makeSummaryRow('Bracing', 'Custom')
    str += makeSummaryRow('At Inflection Points', `${design.bracesAtInflectionPoints ? 'Yes' : 'No'}`)
  }

  str += "</table>";
  document.getElementById("design-info-summary-panel").innerHTML = str
}
